{
  "ascending": "augošā secībā",
  "ascendingSort": "kārtots pēc kolonnas {columnName} augošā secībā",
  "collapse": "Sakļaut",
  "columnSize": "{value} pikseļi",
  "descending": "dilstošā secībā",
  "descendingSort": "kārtots pēc kolonnas {columnName} dilstošā secībā",
  "expand": "Izvērst",
  "resizerDescription": "Nospiediet Enter, lai sāktu izmēru mainīšanu",
  "select": "Atlasīt",
  "selectAll": "Atlasīt visu",
  "sortable": "kārtojamā kolonna"
}
